<template>
  <div :class="containerElClass">
    <template v-for="(option, index) in options" :key="option.id">
      <span
        :class="['row-option', {selected: option.value === selected}]"
        @click="handleSelect(option.value)"
      >
        {{ option.skipTranslation ? option.label : $_translations.value[option.label] }}
      </span>

      <span v-if="index < (options.length - 1)"> | </span>
    </template>
  </div>
</template>

<script setup>
const emits = defineEmits(['update:selected']);

const props = defineProps({
  selected: {
    type: [String, Number, Boolean],
    default: '',
  },
  options: {
    type: Array,
    default: () => [],
  },
  containerElClass: {
    type: [Object, String, Array],
    default: '',
  },
});

const handleSelect = (value) => {
  if (props.selected === value) { return; }

  emits('update:selected', value);
};
</script>
